import { render, staticRenderFns } from "./vehicleTypeControl.vue?vue&type=template&id=6bc7f2bb&scoped=true&"
import script from "./vehicleTypeControl.vue?vue&type=script&lang=js&"
export * from "./vehicleTypeControl.vue?vue&type=script&lang=js&"
import style0 from "./vehicleTypeControl.vue?vue&type=style&index=0&id=6bc7f2bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc7f2bb",
  null
  
)

component.options.__file = "vehicleTypeControl.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VFlex,
  VIcon,
  VTextField,
})
